
/* injects from baggage-loader */

import React from 'react'
import {Route, IndexRedirect, Redirect} from 'react-router'
import IntercomContainer, {IntercomAPI} from 'containers/IntercomContainer'
import {GoogleAnalyticsAPI} from 'components/GoogleAnalytics'

import BaseLayout from 'layouts/BaseLayout'
import AnalyticsLayout from 'layouts/AnalyticsLayout'
import ConfigurationLayout from 'layouts/ConfigurationLayout'
import SidebarContainer from 'containers/SidebarContainer'
import AuthenticatedContainer from 'containers/AuthenticatedContainer'
import DashboardView from 'views/DashboardView'
import NotFoundView from 'views/NotFoundView'
import WizardView from 'views/WizardView'
import UnsubscribeView from 'views/UnsubscribeView'
import MaintenanceView from 'views/MaintenanceView'

import auth from './auth'
import analyticsExplorer from './analyticsExplorer'
import ordersExplorer from './ordersExplorer'
import aggrAttribution from './aggrAttribution'
import crossite from './crossite'
import orders from './orders'
// import billing from './billing'
// import account from './account'
import conversion from './conversion'
import settings from './settings'
// import costsOverview from './costsOverview'
import traffic from './traffic'
import notifications from './notifications'
import dataCollection from './dataCollection'

import {saveToken, exchangeTrackerToken} from 'redux/modules/currentUser/actions'
import {resetGlobalError} from 'redux/modules/error/actions'

const processRedirect = store => (nextState, replace, callback) => {
  const {location} = nextState
  const {channel, error} = location.query || {}

  if (window.opener) {
    if (error) {
      window.opener.postMessage(`costConnectorError`, '*')
    } else {
      window.opener.postMessage(`costConnector:${channel}`, '*')
    }
    window.close()
  }
}

const checkToken = store => (nextState, replace, callback) => {
  const {location} = nextState
  const {__token: token, __trackerToken: trackerToken, ...restQueryParams} = location.query
  if (trackerToken && restQueryParams.frontendId) {
    const {frontendId, email} = location.query
    store.dispatch(exchangeTrackerToken({trackerToken, frontendId, email}))
      .success(() => {
        replace({
          pathname: location.pathname,
          query: restQueryParams
        })
        callback()
      })
      .fail(() => {
        window.parent.postMessage(`resetFrontendId`, '*')
        callback()
      })
  } else if (token) {
    store.dispatch(saveToken(token))
    replace({
      pathname: location.pathname,
      query: restQueryParams
    })
    callback()
  } else {
    callback()
  }
}

const trackRoute = routeName => () => {
  IntercomAPI('trackEvent', `visit_${routeName}`)
}

const onRouteChanged = store => (prevState, nextState) => {
  const {location: {pathname}} = nextState
  IntercomAPI('update')
  GoogleAnalyticsAPI('set', 'page', pathname)
  GoogleAnalyticsAPI('send', 'pageview')
  store.dispatch(resetGlobalError())
  if (window.divvit) {
    window.divvit.pageview()
  }
}

export default store => (
  <Route component={BaseLayout} onChange={onRouteChanged(store)}>
    <Route component={IntercomContainer}>
      <Route path='/unsubscribe' component={UnsubscribeView} />
      <Route path='/connectorCallback' onEnter={processRedirect(store)} />
      {auth(store, checkToken)}
      <Route path='/' component={AuthenticatedContainer} onEnter={checkToken(store)}>
        <Route path='wizard' component={WizardView} onEnter={trackRoute('wizard')} />
        <Route path='wizard/:merchantSiteId' component={WizardView} onEnter={trackRoute('wizard_edit_new')} />
        <Route path='/maintenance' component={MaintenanceView} />
        <Route component={SidebarContainer}>
          <Route
            path='dashboard'
            metric='order_aggr'
            component={DashboardView}
            onEnter={trackRoute('overview')}
          />
          <Route component={AnalyticsLayout}>
            {crossite(store, trackRoute)}
            {analyticsExplorer(store, trackRoute)}
            {/* {billing(trackRoute)} */}
            {ordersExplorer(trackRoute)}
            {aggrAttribution(trackRoute)}
            {orders(trackRoute)}
            {conversion(trackRoute)}
            {dataCollection(trackRoute)}
          </Route>
          <Route component={ConfigurationLayout}>
            {traffic(trackRoute)}
            {notifications(trackRoute)}
            {/* {costsOverview(trackRoute)} */}
            {settings(trackRoute)}
            {/* {account(trackRoute)} */}
          </Route>
          <Redirect from='signup' to='dashboard' />
          <Route path='*' component={NotFoundView} onEnter={trackRoute('404')} />
          <IndexRedirect to='/dashboard' />
        </Route>
      </Route>
    </Route>
  </Route>
)



// WEBPACK FOOTER //
// ./client/routes/index.js